export default __webpack_public_path__ + "static/media/TERMINAL_ICON_08.d9a0236c.svg";